import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../Firebase";

export async function getCart(userId) {
  const cartCollectionRef = collection(db, "cart");
  const q = query(cartCollectionRef, where("userId", "==", userId));
  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
}
